import React from 'react';
import CreateBrandContent from './content';
import { NewBrandProvider } from 'contexts/new-brand.context';

const CreateBrandLayout = () => {
  return (
    <NewBrandProvider>
      <CreateBrandContent />
    </NewBrandProvider>
  );
};

export default CreateBrandLayout;
